export default {"src":"/_next/static/media/bed-icon.6192a96a.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};